import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { configState } from '../../../../recoil/atoms';
import { BranchApi } from "../../../../api/clinic-management";
import { GetBranchesOfUserResponse } from '../../../../api/clinic-management';
import { ErrorMessage, FormikProps, FormikValues, getIn, useFormikContext } from 'formik';

const AutocompleteBranch = (props: any) => {
  const { name } = props;
  const config = useRecoilValue(configState);
  const formik: FormikProps<FormikValues> = useFormikContext();  

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [branches, setBranches] = useState<GetBranchesOfUserResponse>([]);

  const getBranches = () => {
    const branch = new BranchApi(config);
    branch
      .getBranchesOfUser()
      .then((res) => {
        setBranches(res.data);         
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  
  useEffect(() => {
    getBranches();
  }, []);

  const options = branches.map((option) => {
    const firstLetter = option.Name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });
  
  return (
    <>
      {isLoading ? (
        <TextField fullWidth disabled label="Loading Branches..." />
      ) : (        
        <Autocomplete
          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
          getOptionLabel={(option) =>
            option.Name
          }
          sx={{ width: "100%" }}
          onChange={(event, value) => {
            formik.setFieldValue(name, value?.BranchID);
            if (props.setSelectedBranchID) {
              props.setSelectedBranchID(value?.BranchID);
            }
          }}
          loading={!branches}
          value={branches.find(branch => branch.BranchID === formik.values[name])}
          isOptionEqualToValue={(option, value) => option?.BranchID === value?.BranchID}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                label="Choose a branch"
                name={name}
                helperText={<ErrorMessage name={name} />}
                error={getIn(formik.touched, name) && getIn(formik.errors, name)}                
              />
            );
          }}
        />
      )}
    </>
  );
}

export default AutocompleteBranch;